// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3eWxr","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2w4gs"};